/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * How often an outstanding request should be chased (AC8). Reminders are in-platform only — no email and no push notification is sent.
 */
export enum RequestEventRecordAcknowledgementDtoReminderFrequency {
  NONE = "NONE",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
}
